(function () {
  if (window.rwUiBound) return;
  window.rwUiBound = true;
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-rw-prev]');
    var next = e.target.closest('[data-rw-next]');
    if (!prev && !next) return;
    var rail = e.target.closest('[data-rw-rail]');
    if (!rail) return;
    var track = rail.querySelector('[data-rw-track]');
    if (!track) return;
    var step = Math.min(track.clientWidth * 0.85, 420);
    track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
  });
})();
